import React from "react";
import DataProvider from "./components/DataProvider";
import App from "./App";
import { MyApolloProvider } from "./apollo";
import client from "./apollo/client";
import { LoadScript } from "@react-google-maps/api";

// key anterior: AIzaSyD8pHOVvg8_rbh1dOz8jXwuV-AxLlMZBOY
// api key production: AIzaSyAKmzmP6xJp0waJ7s3Tvvb_bukITeH8OBg
// api key producction2: AIzaSyAB25jOlJSFUPhnny4_UWyVeOf9IYfOb24
// AIzaSyC0IvrnI0ZbGmQamfCzw3opHn96fTeNFVI
// AIzaSyD5WELdvXQB1yCTGrozNk7INGXfGmUe6JY
// key eps: AIzaSyCbSUGNZsAC3J1hWzu7Io_otn6hx7vzuag
export default ({ servicePublic }) => {
  return (
    <MyApolloProvider client={client}>
      <LoadScript
        googleMapsApiKey="AIzaSyAqtekmxbCkCPok48tbphvy8XVaOB1HaGQ" //   AIzaSyD5WELdvXQB1yCTGrozNk7INGXfGmUe6JY AIzaSyAecccog4G_o-W9EdopUQU1CZJhU8HQSOU
        libraries={["places"]}
      >
        <DataProvider>
          {(appData) => <App appData={appData} servicePublic={servicePublic} />}
        </DataProvider>
      </LoadScript>
    </MyApolloProvider>
  );
};
